import { Controller } from "@hotwired/stimulus"

// Tabbed sections for the blog editor. Snapshots the Details form on connect
// and, if it has unsaved changes, warns before switching to another tab.
export default class extends Controller {
  static targets = ["tab", "panel", "form", "warning"]

  connect() {
    this.current = this.tabTargets[0]?.dataset.tabName
    this.show(this.current)
    // Snapshot after a frame so progressive enhancers (Tom Select) have settled.
    requestAnimationFrame(() => { this.snapshot = this.serialize() })
  }

  select(event) {
    event.preventDefault()
    const name = event.currentTarget.dataset.tabName
    if (name === this.current) return

    if (this.current === "details" && this.isDirty()) {
      this.pending = name
      this.warningTarget.showModal()
      return
    }
    this.show(name)
  }

  confirmLeave() {
    this.warningTarget.close()
    if (this.pending) {
      // Treat the current state as the new baseline so we don't nag again.
      this.snapshot = this.serialize()
      this.show(this.pending)
      this.pending = null
    }
  }

  cancelLeave() {
    this.warningTarget.close()
    this.pending = null
  }

  show(name) {
    this.current = name
    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.tabPanel !== name
    })
    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.tabName === name
      tab.classList.toggle("border-pink-600", active)
      tab.classList.toggle("text-pink-600", active)
      tab.classList.toggle("border-transparent", !active)
      tab.classList.toggle("text-gray-500", !active)
    })
  }

  // --- helpers ---

  serialize() {
    if (!this.hasFormTarget) return ""
    return new URLSearchParams(new FormData(this.formTarget)).toString()
  }

  isDirty() {
    return this.snapshot !== undefined && this.serialize() !== this.snapshot
  }
}
